module.exports = __webpack_public_path__ + "img/pss-logo.51fed587.jpg";